import { showToast } from '../../utils/toast.util';
export const showUploadInProgressAlert = (uploadingTypes: string[]): void => {
  const message =
    uploadingTypes.length > 1
      ? `As mídias (${uploadingTypes.join(
          ', ',
        )}) ainda estão sendo enviadas. Aguarde o término do upload antes de salvar o exercício.`
      : `A mídia (${uploadingTypes[0]}) ainda está sendo enviada. Aguarde o término do upload antes de salvar o exercício.`;

  if (typeof window !== 'undefined' && (window as any).M?.toast) {
    (window as any).showToast({
      html: message,
      classes: 'orange darken-2',
      displayLength: 4000,
    });
  } else {
    alert(message);
  }
};

export const validateUploadStatus = (
  isAnyUploading: boolean,
  uploadingMediaTypes: string[],
): boolean => {
  if (isAnyUploading) {
    showUploadInProgressAlert(uploadingMediaTypes);
    return false;
  }
  return true;
};
